import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { CtaButton } from "../CtaButton";
import { faqs } from "../../data/content";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-ink-950 px-5 py-16 sm:py-20" data-id="element-132" data-mp="122vemlij93s4">
      <div className="mx-auto max-w-3xl" data-id="element-133" data-mp="1pro5i3kaslfv">
        <SectionHeading title="Frequently Asked Questions" data-id="element-134" data-mp="1pszgoog2ovh0" />
        <ul className="space-y-3" data-id="element-135" data-mp="1urk8q0l688ud">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-2xl bg-ink-800 ring-1 ring-white/10" data-id="element-136" data-mp="1g1v05kar12k2" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-137" data-mp="1kzo8aivm46mz">
                  <span className="font-display text-base font-bold text-white" data-id="element-138" data-mp="2opz311x38a72">{f.q}</span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-139" data-mp="2jr5s9h96qxal" />
                </button>
                <AnimatePresence initial={false} data-id="element-140" data-mp="2yhv5ep67imh3">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-141" data-mp="2tn8q4ax089rq">
                      <p className="px-5 pb-5 text-[15px] leading-relaxed text-slate-300" data-id="element-142" data-mp="3hcjvy6t7oucq">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
        <div className="mt-12" data-id="element-143" data-mp="1i2k2hglqpt3s">
          <CtaButton label="I'm Ready — Get Instant Access" data-id="element-144" data-mp="1i3d2zzu3vmdh" />
        </div>
      </div>
    </section>;
}